module.exports = __webpack_public_path__ + "img/Switzerland.8f847d5c.svg";